'use client';

// npm library imports
import Image from 'next/image';

// style imports
import styles from '@styles/404.module.scss';

// image imports
import steve from '@public/images/crikey-404.png';

export default function Error({ reset }: { reset: () => void }) {
    return (
        <section className={styles.four04}>
            <div>
                <h1 className={styles.crikey}>Crikey!</h1>
                <p className={styles.title}>We encountered an issue loading this page</p>

                <p>Unfortunately there has been an unexpected error and we have failed to load this page. Please refresh this page or try again later.</p>
            </div>
            <div className={styles.image}>
                <Image
                    src={steve}
                    alt="Steve Irwin - The Crocodile Hunder"
                    placeholder="blur"
                />
            </div>
        </section>
    );
}
